import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import { Shimmer } from "components/common"

const InternalTitle = ({ showLoading, subtitle, title }) => {
  return (
    <>
      <Box minHeight="31px">
        {false ? (
          <Shimmer height="31px" mb="4px" mx="auto" width="200px" />
        ) : (
          <Typography
            as="h1"
            color="black"
            fontSize="30px"
            light
            mb={subtitle ? "6px" : 0}
          >
            {title}
          </Typography>
        )}
      </Box>
      {false ? (
        <Shimmer height="19px" mx="auto" width="300px" />
      ) : (
        subtitle && (
          <Typography
            color="black"
            dangerouslySetInnerHTML={{ __html: subtitle }}
            fontSize={{ _: "14px", tablet: "18px" }}
            letterSpacing="0.5px"
            light
          />
        )
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  let subtitle = state.collection.subtitle
  let title = state.collection.title
  return {
    showLoading:
      state.collectionUI.loading && state.collectionUI.loading !== "content",
    subtitle,
    title,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalTitle.propTypes = {
  data: PropTypes.object,
  showLoading: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

const Title = connect(mapStateToProps, mapDispatchToProps)(InternalTitle)

export default Title
